// import * as WebP from '../../node_modules/webp-hero/libwebp/dist/webp';

// WebP.Webp();

// const webpToCanvas = WebP.Module.cwrap('WebpToSDL', 'number', ['array', 'number']);

// check_webp_feature:
//   'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
//   'callback(feature, isSupported)' will be passed back the detection result (in an asynchronous way!)
function checkWebpFeature(feature, callback) {
    const kTestImages = {
        lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
        lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
        alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
        animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
    };

    const img = new Image();
    img.onload = () => {
        const result = (img.width > 0) && (img.height > 0);

        callback(feature, result);
    };

    img.onerror = () => {
        callback(feature, false);
    };

    img.src = `data:image/webp;base64,${kTestImages[feature]}`;
}

// eslint-disable-next-line prefer-const
let supportedCached = null;

const isIos = (/iPad|iPhone|iPod/.test(navigator.platform)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
    && !window.MSStream;

const isWebKit = navigator.userAgent.indexOf('AppleWebKit') >= 0 && navigator.userAgent.indexOf('Chrome/') < 0;

function webpSupported() {
    return new Promise((resolve) => {
        // Should we remove webp polyfill?
        resolve(true);

        // if (supportedCached != null) {
        //     resolve(supportedCached);
        // } else if (isIos || isWebKit) {
        //     supportedCached = false;

        //     resolve(supportedCached);
        // } else {
        //     checkWebpFeature('lossy', (feature, isSupported) => {
        //         supportedCached = isSupported;

        //         resolve(supportedCached);
        //     });
        // }
    });
}

export default function loadWebp(data) {
    return new Promise((resolve) => {
        // eslint-disable-next-line
        if (data && data.type.includes('webp')) {
            webpSupported().then((isSupported) => {
                if (isSupported) {
                    resolve(null);
                }
            });
        } else {
            resolve(null);
        }
    });
}
